import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

export const PaymentSummaryError = ({ sanitizedResponseMessage, onMakeAnotherPayment }) => {
  return (
    <div>
      <div className="summary-container">
        <span>{parse(sanitizedResponseMessage)}</span>
      </div>
      <div className="button-container">
        <button
          type="button"
          className="button primary"
          onClick={() => onMakeAnotherPayment()}
        >
          <span className="labelText">Try again</span>
        </button>
      </div>
    </div>
  );
};

PaymentSummaryError.propTypes = {
  sanitizedResponseMessage: PropTypes.string,
  onMakeAnotherPayment: PropTypes.func
};
